import { render, staticRenderFns } from "./CCTransactions.vue?vue&type=template&id=50c1ffe6&"
import script from "./CCTransactions.vue?vue&type=script&lang=js&"
export * from "./CCTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports